import React from 'react';
import { FETCH_FORMULAIRES_FAILURE, FETCH_FORMULAIRES_REQUEST, FETCH_FORMULAIRES_SUCCESS } from '../Types';

const initialState = {formulaires:[], loadin:false, error:null};

const ListeFormsReducer = (state = initialState, action) => {
    switch (action.type) {
         case FETCH_FORMULAIRES_REQUEST:
            return {...state, loading:true, formulaires:[], error:null};

        case FETCH_FORMULAIRES_SUCCESS:
            return {...state, loading:false, formulaires: action.payload};
            
         case FETCH_FORMULAIRES_FAILURE:
            return {...state, loading:false, formulaires:[], error: action.payload};
    
        default:
            return state;
    }

   
};

export default ListeFormsReducer;